import Section from "@/components/ui/section";
import React from "react";
import Image from "next/image";
import Slick from "@/components/ui/carousel/slick";
export default function CaseStories() {
  const data = [
    {
      title: "Lorem ipsum dolor sit amet",
      image: "/images/home/home_banner_02.webp",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vestibulum odio id bibendum sollicitudin. Nulla finibus sed ante non semper. Aliquam in enim euismod, sollicitudin sem facilisis, vestibulum velit. Quisque tellus sem",
    },
    {
      title: "Lorem ipsum dolor sit amet",
      image: "/images/home/home_banner_02.webp",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vestibulum odio id bibendum sollicitudin. Nulla finibus sed ante non semper. Aliquam in enim euismod, sollicitudin sem facilisis, vestibulum velit. Quisque tellus sem",
    },
    {
      title: "Lorem ipsum dolor sit amet",
      image: "/images/home/home_banner_02.webp",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vestibulum odio id bibendum sollicitudin. Nulla finibus sed ante non semper. Aliquam in enim euismod, sollicitudin sem facilisis, vestibulum velit. Quisque tellus sem",
    },
  ];
  var responsive = [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
      },
    },
  ];

  return (
    <Section className="mb-12">
      <h2 className="text-blue text-center lg:mb-12 mb-8">
        Stories of people we serve
      </h2>
      <Slick
        responsive={responsive}
        autoplay={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {data?.map((row, key) => (
          <Block data={row} key={"report" + key} />
        ))}
      </Slick>
    </Section>
  );
}
const Block = ({ data }) => {
  const { title, image, description } = data;
  return (
    <div className="flex md:flex-row flex-col w-full h-auto gap-6 lg:gap-12 lg:px-8 px-4">
      <div className="shrink-0 group flex justify-start items-start relative overflow-hidden lg:w-[300px] lg:h-[300px] md:w-[200px] w-full h-[200px] rounded">
        <Image
          src={image}
          alt={title}
          fill
          className="object-cover object-center w-full"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
        />
      </div>
      <div className="flex flex-col items-start justify-start w-full h-full">
        <p className="text-darkBlue mb-2 md:text-[20px] text-base text-left font-medium">
          {title}
        </p>
        <p className="md:text-base text-sm lg:!leading-normal text-left">
          {description}
        </p>

        {/* <KnowMore
          target="_blank"
          path={link}
          text={"Read More"}
          variant="darkBlue"
          className="mt-auto"
        /> */}
      </div>
    </div>
  );
};
